// src/components/home/PartnersCarousel.jsx
import { useRef, useEffect } from 'react';
import { motion, useAnimationControls } from 'framer-motion';
import Images from '../Images';

const PartnersCarousel = () => {
  const partners = [
    { name: 'Telecel', image: Images.telecel },
    { name: 'AT', image: Images.at },
    { name: 'Graphic', image: Images.graphic },
    { name: 'Nalo', image: Images.nalo },
  ];

  // Only 2 copies needed — translate -50% = one full set
  const allPartners = [...partners, ...partners];

  return (
    <section className="py-16 bg-white overflow-hidden">
      <div className="max-w-8xl mx-auto px-6 lg:px-16">
        <h2 className="text-3xl font-bold text-center mb-4">Our Partners</h2>
        <p className="text-gray-600 text-center mb-12 max-w-2xl mx-auto">
          We collaborate with industry leaders to deliver world-class solutions and services
          that drive innovation and growth.
        </p>

        <div className="relative overflow-hidden">
          <motion.div
            className="flex gap-16 items-center w-max"
            animate={{ x: ["0%", "-50%"] }}
            transition={{
              duration: 20,         // consistent across all screen sizes
              repeat: Infinity,
              ease: "linear",
              repeatType: "loop",
            }}
          >
            {allPartners.map((partner, index) => (
              <motion.div
                key={index}
                whileHover={{ scale: 1.1 }}
                transition={{ duration: 0.1 }}
                className="w-32 h-32 rounded-full flex items-center justify-center flex-shrink-0 overflow-hidden bg-white shadow-md"
              >
                <img
                  src={partner.image}
                  alt={partner.name}
                  className="w-full h-full object-cover"
                />
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PartnersCarousel;